import {throwIfUndefined} from '@coolcolduk/util';
import {mapTradeDbToType, type Trade, type TradeDb} from '@cp/model';
import {useLayoutEffect} from 'react';
import {listTradesQuery, TRADES_PAGE_SIZE} from '../../api/trade/listTrades';
import {FirestoreCursor} from '../../types/FirestoreCursor';
import useFunctionPagination from '../helper/function/useFunctionPagination';
import {useAuth} from '../users/useAuth';

export default function useTrades(sessionId: string) {
  const user = useAuth();
  const uid = user?.id;

  const pagination = useFunctionPagination<Trade, TradeDb>(
    (cursor: FirestoreCursor) =>
      listTradesQuery(uid || '', TRADES_PAGE_SIZE, sessionId, cursor).then((snapshot) => snapshot.docs),
    mapTradeDbToType,
    {
      skip: uid === undefined,
      countFn: () => listTradesQuery(throwIfUndefined(uid), undefined, sessionId).then((snapshot) => snapshot.size),
    },
  );

  useLayoutEffect(() => {
    if (uid !== undefined) {
      pagination.clearData();
    }
  }, [uid, pagination.clearData]);

  return pagination;
}
